import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { isEqual } from 'lodash';
import { Subject } from 'rxjs';
import { DateFormatterService } from '../../providers/date.formatter/date.formatter.service';
import { TimeRange } from '../../models/time-range';
import { TimePickerService } from '../../providers/time-picker/time-picker.service';
import { TimeRangeKey } from '../time-picker/types';

@Component({
  selector: 'selected-time-range',
  templateUrl: './selected.time.range.template.html',
  styleUrls: ['./selected.time.range.style.scss']
})
export class SelectedTimeRangeComponent implements OnInit, OnDestroy {
  timeFrom: string;
  timeTo: string;
  stop = false;

  private _timeRange: TimeRange;
  private readonly _unsubscribe: Subject<void> = new Subject();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private readonly dateFormatterService: DateFormatterService,
    private timePickerService: TimePickerService
  ) {}

  ngOnInit() {
    this._clearChartZoom();
    this._handleTimeRange();
  }

  ngOnDestroy() {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }

  get timeRange(): TimeRange {
    return this._timeRange;
  }

  set timeRange(value: TimeRange) {
    this._timeRange = value;
    this.changeDetectorRef.markForCheck();
  }

  private _clearChartZoom(): void {
    const graphZoomed = sessionStorage.getItem('graphZoomed');
    if (graphZoomed === 'true') {
      const lastTimeRange: TimeRange = this.timePickerService.lastTimeRange;
      this.timePickerService.replaceTimeRangeOnChartZoom(lastTimeRange, true, false);
    }
  }

  private _handleTimeRange(): void {
    this.timePickerService
      .getActiveTimeRange$()
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((item: TimeRange) => {
        if (!isEqual(this.timeRange, item)) {
          this.stop = this.timeRange?.key === TimeRangeKey.LAST_1H;
          this.timeRange = item;
          this.inputParamsChanged();
        }
      });
  }

  private inputParamsChanged(): void {
    if (!this.stop) {
      const range = this.timeRange.getTimestampRange();
      this.timeFrom = this.dateFormatterService.getDateTime(range.fromTime);
      this.timeTo = this.dateFormatterService.getDateTime(range.toTime);
    }
    this.stop = true;
  }
}
